import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a/conversations/')({
  component: Component,
});

function Component() {
  return (
    <div className="hidden h-full items-center justify-center text-muted-foreground xl:flex">
      Select a conversation
    </div>
  );
}
